import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

import { KEYS } from '~shared/api/query-keys';

export const deleteUserAPI = async (userId: string) => {
  await baseAPI.delete(`/users/${userId}`);
  return;
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => deleteUserAPI(userId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.USERS] });
      void queryClient.invalidateQueries({ queryKey: [KEYS.UNLINKED_CRM_USERS] });
    },
  });
};

